import { render, staticRenderFns } from "./paperListPage.vue?vue&type=template&id=1f878c1b&scoped=true"
import script from "./paperListPage.vue?vue&type=script&lang=js"
export * from "./paperListPage.vue?vue&type=script&lang=js"
import style0 from "./paperListPage.vue?vue&type=style&index=0&id=1f878c1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f878c1b",
  null
  
)

export default component.exports